import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
  input,
} from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { ForeachInputModel, WidgetInput } from '@trackback/widgets';
import { DynamicWidgetDirective } from '@app/directives/dynamic-widget.directive';
import { ParsePipe } from '@app/pipes/parse.pipe';
import { AttachPipe } from '@app/pipes/attach.pipe';

@Component({
  selector: 'tb-for',
  standalone: true,
  imports: [DynamicWidgetDirective, AsyncPipe, ParsePipe, AttachPipe],
  template: `
    @for (
      item of input().in | parse: context() | async;
      track item;
      let idx = $index;
      let last = $last;
      let total = $count
    ) {
      <ng-container
        [dynamicWidget]="input().template"
        [context]="
          context()
            | attach: item : input().dataAlias ?? 'foreachData'
            | attach
              : {
                  index: idx,
                  first: idx === 0,
                  last,
                  odd: idx % 2 !== 0,
                  even: idx % 2 === 0,
                  total,
                }
              : input().metaAlias ?? 'foreachMeta'
        "
      />
    }
  `,
  styles: `
    tb-for {
      display: contents;
    }
  `,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export default class ForComponent {
  input =
    input.required<ForeachInputModel<WidgetInput, Record<string, unknown>>>();
  context = input.required<Record<string, unknown>>();
}
